export class Resp {
	constructor(public status:string="", public msg:string="", public data:any=[]){}
}
